// moment.js language configuration
// language : hungarian (hu)
// author : Adam Brunner : https://github.com/adambrunner
var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');

function translate(number, withoutSuffix, key, isFuture) {
  var num = number,
      suffix;

  switch (key) {
    case 's':
      return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';

    case 'm':
      return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');

    case 'mm':
      return num + (isFuture || withoutSuffix ? ' perc' : ' perce');

    case 'h':
      return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');

    case 'hh':
      return num + (isFuture || withoutSuffix ? ' óra' : ' órája');

    case 'd':
      return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');

    case 'dd':
      return num + (isFuture || withoutSuffix ? ' nap' : ' napja');

    case 'M':
      return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');

    case 'MM':
      return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');

    case 'y':
      return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');

    case 'yy':
      return num + (isFuture || withoutSuffix ? ' év' : ' éve');
  }

  return '';
}

function week(isFuture) {
  return (isFuture ? '' : 'múlt ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

require("../moment").lang('hu', {
  months: "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
  monthsShort: "jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),
  weekdays: "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
  weekdaysShort: "v_h_k_sze_cs_p_szo".split("_"),
  longDateFormat: {
    LT: "H:mm",
    L: "YYYY.MM.DD.",
    LL: "YYYY. MMMM D.",
    LLL: "YYYY. MMMM D., LT",
    LLLL: "YYYY. MMMM D., dddd LT"
  },
  calendar: {
    sameDay: '[ma] LT[-kor]',
    nextDay: '[holnap] LT[-kor]',
    nextWeek: function nextWeek() {
      return week.call(this, true);
    },
    lastDay: '[tegnap] LT[-kor]',
    lastWeek: function lastWeek() {
      return week.call(this, false);
    },
    sameElse: 'L'
  },
  relativeTime: {
    future: "%s múlva",
    past: "%s",
    s: translate,
    m: translate,
    mm: translate,
    h: translate,
    hh: translate,
    d: translate,
    dd: translate,
    M: translate,
    MM: translate,
    y: translate,
    yy: translate
  },
  ordinal: '%d.',
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 7 // The week that contains Jan 1st is the first week of the year.

  }
});